import { render, staticRenderFns } from "./AIAnalysis.vue?vue&type=template&id=22639852&scoped=true&"
import script from "./AIAnalysis.vue?vue&type=script&lang=js&"
export * from "./AIAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AIAnalysis.vue?vue&type=style&index=0&id=22639852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22639852",
  null
  
)

export default component.exports